import { useBetsByRound } from '@/api/bets';
import { UseBetsByRoundProps } from '@/api/bets/queries/useBetsByRound/props';
import { doubleScoreboardBets } from '@/constants/doubleScoreboardBets';
import { fortuneDoubleScoreboardBets } from '@/constants/fortuneDoubleScoreboardBets';
import { scoreboardBets } from '@/constants/scoreboardBets';
import { GameID, GameIDType } from '@/enums/gameId';
import { OrderByOptions } from '@/enums/order-by';
import { useGameReportSearchParams } from '@/hooks/gameReport/useGameReportSearchParams';
import { DetailedBet } from '@/models/detailed-bet';
import { ErrorCard, TableWithPagination } from '@starsoft/common/components';
import { TableGridColumn } from '@starsoft/common/src/components/TableGrid/props';

export default function GameScoreboard() {
  const { roundId, gameId } = useGameReportSearchParams();
  const {
    page,
    error,
    refetch,
    isPending,
    data: scoreboard,
    fetchNextPage,
    setCurrentPage,
    fetchPreviousPage,
  } = useBetsByRound<'paginated', UseBetsByRoundProps>({
    type: 'paginated',
    gameRoundId: roundId as string,
    gameId: gameId as GameIDType,
    sortOrder: OrderByOptions.Descending,
  });

  function getScoreboardByGame(): TableGridColumn<DetailedBet>[] {
    switch (gameId?.toString()) {
      case GameID.Crash?.toString():
      case GameID.CrashTrenball?.toString():
      case GameID.Slide?.toString():
        return scoreboardBets;
      case GameID.Double?.toString():
        return doubleScoreboardBets;
      case GameID.Frost?.toString():
        return fortuneDoubleScoreboardBets;
      default:
        return scoreboardBets;
    }
  }

  if (error) {
    return <ErrorCard error={error} refetch={refetch} />;
  }

  return (
    <TableWithPagination
      columns={getScoreboardByGame()}
      page={page}
      error={error}
      refetch={refetch}
      //@ts-ignore
      data={scoreboard as DetailedBet[]}
      isLoading={isPending}
      fetchNextPage={fetchNextPage}
      setCurrentPage={setCurrentPage}
      fetchPreviousPage={fetchPreviousPage}
    />
  );
}
